import { PackDetail } from '@bpm-web-app/components/pages';

export default function PackBySlugPage() {
    return <PackDetail />;
}
